import {createStrokeSVG} from './TEMPLATE'

// tabler: ban
export const CircleBanSign_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', 'M5.7 5.7l12.6 12.6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
